(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["loafypaws-cwill-protection-bridge"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__loafypawsCwillProtectionBridge) return;
  window.__loafypawsCwillProtectionBridge = true;

  const checkboxSelector = '#seel_widget input.seel_widget--title_line--checkbox';
  const modalSelector = '#seel-learn-more-modal';
  const defaultAppliedKey = 'loafypaws_cwill_default_applied';
  const userChoiceKey = 'loafypaws_cwill_user_choice';

  const readStorage = (storage, key) => {
    try {
      return storage.getItem(key);
    } catch {
      return null;
    }
  };

  const writeStorage = (storage, key, value) => {
    try {
      storage.setItem(key, value);
    } catch {
      // Storage can be unavailable in a privacy-restricted browser.
    }
  };

  const removeStorage = (storage, key) => {
    try {
      storage.removeItem(key);
    } catch {
      // Storage can be unavailable in a privacy-restricted browser.
    }
  };

  const isVisible = (element) => {
    if (!element) return false;
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  };

  const protectLearnMoreModal = () => {
    const dialog = document.querySelector(modalSelector);
    if (!dialog) return;

    const host = dialog.querySelector('#seel-learn-more-modal-shadow-host');
    if (!host) return;

    if (dialog.dataset.loafypawsModalGuards !== 'true') {
      const stopThemeEscape = (event) => {
        if (event.key === 'Escape' && dialog.open) {
          // Stop the theme's document-level drawer handler, but let the native
          // dialog cancel event reach CWILL so it can remove its visible class.
          event.stopPropagation();
        }
      };

      const clearClosedModalLayer = () => {
        if (!dialog.open) {
          host.classList.remove('seel-learn-more-modal--visible');
          host.style.removeProperty('opacity');
          host.style.removeProperty('visibility');
          host.style.removeProperty('pointer-events');
          dialog.classList.remove('window-overlay', 'is-active');
          dialog.removeAttribute('inert');
          host.removeAttribute('inert');
          dialog.dataset.loafypawsFocusReady = 'false';
        }
      };

      const cleanupAfterClose = () => {
        clearClosedModalLayer();
        window.requestAnimationFrame(clearClosedModalLayer);
        window.setTimeout(clearClosedModalLayer, 0);
        window.setTimeout(clearClosedModalLayer, 500);
      };

      dialog.addEventListener('keydown', stopThemeEscape);
      dialog.addEventListener('close', cleanupAfterClose);

      dialog.dataset.loafypawsModalGuards = 'true';
    }

    if (!dialog.open) {
      // CWILL normally removes this class during its close transition. If the
      // browser closes the native dialog directly, clear the stale hit layer.
      host.classList.remove('seel-learn-more-modal--visible');
      host.style.removeProperty('opacity');
      host.style.removeProperty('visibility');
      host.style.removeProperty('pointer-events');
      dialog.classList.remove('window-overlay', 'is-active');
      dialog.removeAttribute('inert');
      host.removeAttribute('inert');
      dialog.dataset.loafypawsFocusReady = 'false';
      return;
    }

    // The theme's drawer trap exempts this class from its sibling inert pass.
    // `is-active` is required because the theme's overlay CSS otherwise sets
    // opacity to zero and keeps a closed overlay in the hit-test layer.
    dialog.classList.add('window-overlay', 'is-active');
    dialog.removeAttribute('inert');
    host.removeAttribute('inert');

    // CWILL adds this class on a delayed animation frame. Sync it immediately
    // so a fast click does not leave an open but visually empty dialog.
    host.classList.add('seel-learn-more-modal--visible');
    host.style.setProperty('opacity', '1');
    host.style.setProperty('visibility', 'visible');
    host.style.setProperty('pointer-events', 'auto');

    if (dialog.dataset.loafypawsFocusReady === 'true') return;
    dialog.dataset.loafypawsFocusReady = 'true';
    window.requestAnimationFrame(() => {
      if (!dialog.isConnected || !dialog.open) return;
      dialog.removeAttribute('inert');
      host?.shadowRoot?.querySelector('#seel-learn-more-close')?.focus({ preventScroll: true });
    });
  };

  const applyDefaultProtection = () => {
    const checkbox = document.querySelector(checkboxSelector);
    const widget = checkbox?.closest('#seel_widget');
    if (!checkbox || checkbox.disabled || !isVisible(widget) || checkbox.checked) return;

    const drawer = widget.closest('#CartDrawer');
    if (drawer && !drawer.classList.contains('is-active')) return;

    const userChoice = readStorage(window.sessionStorage, userChoiceKey);
    const defaultApplied = readStorage(window.sessionStorage, defaultAppliedKey);
    const appChoice = readStorage(window.localStorage, 'pp_gsp-checked');

    // Respect an existing CWILL choice, including a persistent opt-out.
    if (userChoice !== null || defaultApplied === '1' || appChoice !== null) return;
    if (typeof window.seel_checkboxChange !== 'function') return;

    writeStorage(window.sessionStorage, defaultAppliedKey, '1');
    checkbox.checked = true;

    try {
      const result = window.seel_checkboxChange(checkbox, {
        stopPropagation() {},
        preventDefault() {}
      });
      Promise.resolve(result).catch(() => {
        if (readStorage(window.sessionStorage, userChoiceKey) === null) {
          removeStorage(window.sessionStorage, defaultAppliedKey);
        }
      });
    } catch {
      removeStorage(window.sessionStorage, defaultAppliedKey);
    }
  };

  const handleClick = (event) => {
    const checkbox = event.target?.closest?.(checkboxSelector);
    if (checkbox) {
      writeStorage(window.sessionStorage, userChoiceKey, checkbox.checked ? 'on' : 'off');
      return;
    }

    if (event.target?.closest?.('[data-target="CartDrawer"]')) {
      window.setTimeout(run, 0);
    }

    if (event.target?.closest?.('#seel_widget .seel_widget--title_line a')) {
      window.setTimeout(protectLearnMoreModal, 0);
    }
  };

  const run = () => {
    protectLearnMoreModal();
    applyDefaultProtection();
  };

  document.addEventListener('click', handleClick, true);

  const observer = new MutationObserver(run);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  run();
})();
  } catch(e) { console.error(e); }
})();

})();
